const entityTypes = {
  COMPANY: 'JURIDICA',
  PERSON: 'FISICA',
};

export default entityTypes;
